/** Copyright © 2024 Qcells. All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized use,
 * duplication, or distribution of software is strictly prohibited.
 */
import type { Role, WebContextRoot } from 'hems';

import type { ValueType } from 'hems/common/utils';

export const RoleWebMap: Record<Role, WebContextRoot> = {
  admin: '/admin',
  dev: '/admin',
  installer: '/installer',
  user: '/user',
  service: '/admin',
};

/** Application Store Type */
export const APP_STORE_TYPE = {
  GOOGLE: 'google',
  APPLE: 'apple',
} as const;

export type AppStoreType = ValueType<typeof APP_STORE_TYPE>;

export const MOBILE_APP_TYPE = {
  PRO: 'pro',
  HOME: 'home',
} as const;

export type MobileAppType = ValueType<typeof MOBILE_APP_TYPE>;
